import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Features } from "./components/Features";
import { FAQ } from "./components/FAQ";
import { Footer } from "./components/Footer";
import { Legal } from "./components/Legal";
import { ContactModal } from "./components/ContactModal";
import { SubscriptionPage } from "./components/SubscriptionPage";
import { CookieConsent } from "./components/CookieConsent";
import { VideoCallSample } from "./components/VideoCallSample";

import JoinzyFavicon from "./joinzy_new_just_logo.png";

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const isTermsRoute = location.pathname === '/termsandconditions';
  const isContactRoute = location.pathname === '/contact-us';
  const isSubscriptionRoute = location.pathname === '/subscription';

  const [isLegalOpen, setIsLegalOpen] = useState(isTermsRoute);
  const [isContactOpen, setIsContactOpen] = useState(isContactRoute);

  useEffect(() => {
    if (isTermsRoute) setIsLegalOpen(true);
  }, [isTermsRoute]);

  useEffect(() => {
    if (isContactRoute) setIsContactOpen(true);
  }, [isContactRoute]);

  const handleCloseLegal = () => {
    setIsLegalOpen(false);
    if (isTermsRoute) navigate('/');
  };

  const handleCloseContact = () => {
    setIsContactOpen(false);
    if (isContactRoute) navigate('/');
  };

  return (
    <LanguageProvider>
      <div className="App" data-testid="joinzy-app">
        <Navbar />
        <main>
          {isSubscriptionRoute ? (
            <SubscriptionPage />
          ) : (
            <>
              <Hero />
              <Features />
              <FAQ onOpenContact={() => setIsContactOpen(true)} />
            </>
          )}
        </main>
        <Footer
          onOpenLegal={() => setIsLegalOpen(true)}
          onOpenContact={() => setIsContactOpen(true)}
        />
        <Legal isOpen={isLegalOpen} onClose={handleCloseLegal} />
        <ContactModal isOpen={isContactOpen} onClose={handleCloseContact} />
        <CookieConsent />
      </div>
    </LanguageProvider>
  );
}

function App() {
  useEffect(() => {
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/png';
    link.rel = 'shortcut icon';
    link.href = JoinzyFavicon;
    document.getElementsByTagName('head')[0].appendChild(link);
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/video-call-sample" element={<VideoCallSample />} />
        <Route path="/*" element={<AppContent />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
